<template>
  <div class="baseButton" :style="styles">
    <component
      :is="isTag"
      ref="button"
      class="baseButton__button"
      :class="[
        {disabled : isDisabled},
        design !== '' ? 'baseButton__button--' + design : ''
      ]"
      @click.prevent="clicked"
    >
      <span
        class="baseButton__button__label"
        :class="{disabled : isDisabled && !btnLabelEnable}"
        v-html="label"
      ></span>
    </component>
  </div>
</template>

<script>
export default {
  name: 'LpBaseButton',
  props: {
    // a タグなどに変更したい場合に使用
    tag: {
      type: String,
      default: 'span'
    },
    label: {
      type: String,
      default: '登録して占う'
    },
    href: {
      type: String,
      default: '/'
    },
    isDisabled:{
      type: Boolean,
      default: false
    },
    btnLabelEnable: {
      type: Boolean,
      default: false
    },
    design: {
      type: String,
      default: ''
    },
    colorScheme: {
      type: Object,
      default(){
        return {}
      }
    },
    gradStart: {
      type: String,
      default: null,
    },
    gradEnd: {
      type: String,
      default: null,
    },
  },
  computed: {
    // タグを設定
    isTag () {
      return this.tag
    },
    styles(){
      let grad
      if(!!this.gradStart && !!this.gradEnd){
        grad = `linear-gradient(86.51deg, ${this.gradStart} 21.4%, ${this.gradEnd} 76.64%)`
      }else{
        if(!!this.colorScheme.buttonBackground){
          grad = this.colorScheme.buttonBackground
        }else{
          grad = `linear-gradient(86.51deg, ${this.colorScheme.gradStart} 21.4%, ${this.colorScheme.gradEnd} 76.64%)`
        }
      }

      return {
        // '--key-color': !!this.colorScheme.keyColor ? this.colorScheme.keyColor : 'black',
        // '--second': !!this.colorScheme.second ? this.colorScheme.second : 'white',
        '--grad-start': !!this.gradStart ? this.gradStart : this.colorScheme.gradStart,
        '--grad-end': !!this.gradEnd ? this.gradEnd : this.colorScheme.gradEnd,
        '--def-gradient': grad,
      }
    },
  },
  mounted () {
    // href 設定
    if (this.tag === 'a') {
      this.$refs.button.setAttribute('href', this.href)
    }
  },
  methods: {
    clicked(){
      if(!this.isDisabled) {
        this.$emit('clicked')
      }
    }
  }
}</script>

<style lang="scss">
@import "../../../../../../sass/commons/commonVariables.scss";
//$l_col_keycolor: var(--key-color);
//$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);
$l_def_gradient: var(--def-gradient);

.baseButton{
  $root: &;
  text-align: center;
  width: 100%;

  &__button{
    width: 100%;
    min-width: 270px;
    display: inline-block;
    font-weight: 700;
    font-size: 14px;
    color: $col_white;
    text-decoration: none;
    padding: 16px 32px;
    border-radius: 50px;
    cursor: pointer;
    position: relative;
    z-index: 1;
    background: $l_def_gradient;
    // box-shadow: 5px 5px 15px rgba(0,0,0,.15);
    text-align: center;

    &.disabled{
      background: $col_white;
      border: 2px solid $col_temp_gray3;
      pointer-events: none;
    }

    &__label{
      color: $col_temp_key1;
      background: $l_def_gradient;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;

      &.disabled{
        background: $col_temp_gray3;
        -webkit-background-clip: text;
      }

    &::before{
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      box-sizing: border-box;
      border-radius: 2em;
      padding: 2px;
      width: 100%;
      height: 100%;
      background: $col_white;
      background-clip: content-box;
      content: "";
    }

    }
    // design === fill
    &--fill {
      #{$root}__button__label {
        color: #fff;
        -webkit-text-fill-color: initial;
        &::before {
          display: none;
        }
      }
      &.disabled {
        #{$root}__button__label {
          color: $col_temp_gray3;
        }
      }
    }

    // design === no-frame
    &--no-frame {
      background: white;
    }

    // design === primary
    &--primary {
      background: #4BCB7B;
      padding: 13px 32px;
      box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.25);
      #{$root}__button__label {
        -webkit-background-clip: unset;
        -webkit-text-fill-color: unset;
        background: none;
        color: #4BCB7B;
        font-weight: bold;
        font-size: 22px;
        &::after {
          content: '';
          display: inline-block;
          width: 30px;
          height: 30px;
          border-radius: 100px;
          background: url(/static/img/common/arrow_right_white.png) no-repeat 55% 50%/22px auto #4BCB7B;
          vertical-align: -6px;
          margin-left: 3px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/partials/LpBaseButton.vue